import React, {Fragment} from 'react';
import {Formik, FormikConfig, Form as FormikForm, FormikValues} from 'formik';
import {debounce, useFormikContext, usePrevious, useUpdateEffect, objectDifference} from 'helpers';
import css from './form.module.scss';

interface ExtraProps {
  id?: string;
  className?: string;
  delay?: boolean;
}

export const Form = <Values extends FormikValues = FormikValues>({ id, delay, onSubmit, className = '', ...props }: FormikConfig<Values> & ExtraProps) => {
  if (delay && onSubmit) {
    onSubmit = debounce(onSubmit, 300);
  }
  return (
    <Formik initialValues={{}} enableReinitialize onSubmit={onSubmit} {...props}>
      <FormikForm className={css(className)} id={id}>
        <Content {...props} />
      </FormikForm>
    </Formik>
  );
}

function Content({ children, onChange }) {
  const context = useFormikContext();
  return (
    <Fragment>
      { typeof children == 'function' ? children(context) : children }
      { onChange &&
        <Listener onChange={onChange} values={context.values} />
      }
      {/*<pre>{ JSON.stringify(useFormikContext().values, null, 2) }</pre>*/}
    </Fragment>
  );
}

function Listener({ onChange, values }) {
  const prevValues = usePrevious(values);
  useUpdateEffect(() => {
    onChange(values, objectDifference(values, prevValues));
  }, [ values ]);
  return null;
}
